export interface ICoverData {
    mainTitle: string;
    subTitle: string;
    reportingPeriod: string;
    companyLogo: string | null;
}
